<template>
	<div>
      <h1>Processando Autenticação...</h1>
    </div>
</template>

<script>


export default {

	created() {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');

      if (code) {
        window.opener.postMessage({ code }, window.location.origin);  
        window.close();
      } else {
        console.error('Nenhum código de autorização encontrado na URL.');
      }
    },

};
</script>
  
